var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBigcontact4(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 251,
    viewBox: "0 0 250 251",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6515)"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("line", {
    x1: 17.9658,
    y1: 120.093,
    x2: 17.9658,
    y2: -21.4222,
    stroke: "url(#paint0_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 52.9658,
    y1: 120.093,
    x2: 52.9658,
    y2: -21.4222,
    stroke: "url(#paint1_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 88.9658,
    y1: 120.093,
    x2: 88.9658,
    y2: -21.4222,
    stroke: "url(#paint2_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 124.966,
    y1: 120.093,
    x2: 124.966,
    y2: -21.4222,
    stroke: "url(#paint3_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 160.966,
    y1: 120.093,
    x2: 160.966,
    y2: -21.4222,
    stroke: "url(#paint4_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 195.966,
    y1: 120.093,
    x2: 195.966,
    y2: -21.4222,
    stroke: "url(#paint5_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 231.966,
    y1: 120.093,
    x2: 231.966,
    y2: -21.4222,
    stroke: "url(#paint6_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 18.954,
    x2: 258.387,
    y2: 18.954,
    stroke: "url(#paint7_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 77.954,
    x2: 258.387,
    y2: 77.954,
    stroke: "url(#paint8_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("line", {
    x1: -4.37114e-8,
    y1: 47.954,
    x2: 258.387,
    y2: 47.954,
    stroke: "url(#paint9_linear_75_6515)"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    fill: "url(#paint10_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_75_6515)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.4736 70.7716C42.4736 70.0195 43.0833 69.4098 43.8354 69.4098H68.347C69.0991 69.4098 69.7088 70.0195 69.7088 70.7716C69.7088 71.5236 69.0991 72.1333 68.347 72.1333H43.8354C43.0833 72.1333 42.4736 71.5236 42.4736 70.7716ZM45.1971 59.8775C45.1971 59.1254 45.8068 58.5158 46.5589 58.5158C47.311 58.5158 47.9207 59.1254 47.9207 59.8775V66.6863C47.9207 67.4384 47.311 68.048 46.5589 68.048C45.8068 68.048 45.1971 67.4384 45.1971 66.6863V59.8775ZM52.0059 59.8775C52.0059 59.1254 52.6156 58.5158 53.3677 58.5158C54.1198 58.5158 54.7294 59.1254 54.7294 59.8775V66.6863C54.7294 67.4384 54.1198 68.048 53.3677 68.048C52.6156 68.048 52.0059 67.4384 52.0059 66.6863V59.8775ZM57.4529 59.8775C57.4529 59.1254 58.0626 58.5158 58.8147 58.5158C59.5668 58.5158 60.1765 59.1254 60.1765 59.8775V66.6863C60.1765 67.4384 59.5668 68.048 58.8147 68.048C58.0626 68.048 57.4529 67.4384 57.4529 66.6863V59.8775ZM64.2617 59.8775C64.2617 59.1254 64.8714 58.5158 65.6235 58.5158C66.3756 58.5158 66.9852 59.1254 66.9852 59.8775V66.6863C66.9852 67.4384 66.3756 68.048 65.6235 68.048C64.8714 68.048 64.2617 67.4384 64.2617 66.6863V59.8775ZM42.4736 53.2032C42.4736 52.2862 42.9917 51.4479 43.8119 51.0379L55.0085 45.4395C55.6901 45.0987 56.4923 45.0987 57.1739 45.4395L68.3705 51.0379C69.1907 51.4479 69.7088 52.2862 69.7088 53.2032V54.7331C69.7088 56.0701 68.6249 57.154 67.2879 57.154H44.8945C43.5575 57.154 42.4736 56.0701 42.4736 54.7331V53.2032ZM56.0912 53.0687C56.4524 53.0687 56.7987 52.9253 57.0541 52.6699C57.3095 52.4145 57.4529 52.0681 57.4529 51.707C57.4529 51.3458 57.3095 50.9994 57.0541 50.7441C56.7987 50.4887 56.4524 50.3452 56.0912 50.3452C55.73 50.3452 55.3837 50.4887 55.1283 50.7441C54.8729 50.9994 54.7294 51.3458 54.7294 51.707C54.7294 52.0681 54.8729 52.4145 55.1283 52.6699C55.3837 52.9253 55.73 53.0687 56.0912 53.0687Z",
    fill: "#4583FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.7367 60.9766L63.7374 60.9768C68.8078 62.4513 73.5892 64.7807 77.8756 67.8646L63.7367 60.9766ZM63.7367 60.9766C63.4662 60.8982 63.1794 60.8943 62.9069 60.9654C62.6343 61.0366 62.3861 61.1801 62.1884 61.3808C61.9907 61.5814 61.851 61.8318 61.7839 62.1054C61.7169 62.379 61.725 62.6656 61.8075 62.935L61.8079 62.9361M63.7367 60.9766L61.8079 62.9361M61.8079 62.9361L63.6319 68.8649L63.7145 69.1333M61.8079 62.9361L63.7145 69.1333M63.7145 69.1333L63.6319 69.4018L61.8079 75.3305L61.8075 75.3316C61.725 75.601 61.7169 75.8876 61.7839 76.1612C61.851 76.4348 61.9907 76.6852 62.1884 76.8858C62.3861 77.0865 62.6343 77.23 62.9069 77.3012M63.7145 69.1333L77.876 70.4018C73.5895 73.4858 68.808 75.8152 63.7374 77.2898L63.7367 77.29C63.4662 77.3684 63.1795 77.3723 62.9069 77.3012M62.9069 77.3012C62.9069 77.3012 62.9069 77.3012 62.9069 77.3012L63.1595 76.3336L62.9069 77.3012ZM77.4642 69.3899L78.354 69.8462C78.4671 69.6256 78.5261 69.3812 78.5261 69.1333C78.5261 68.8854 78.4671 68.641 78.354 68.4204L78.354 68.4204C78.241 68.1999 78.0771 68.0095 77.876 67.8648L77.4642 69.3899Z",
    fill: "#C1D6FF",
    stroke: "#F5F8FF",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("rect", {
    x: 16.5,
    y: 17.125,
    width: 87,
    height: 87,
    rx: 43.5,
    stroke: "url(#paint11_linear_75_6515)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.527 212.625V206.62H28.6794V204.477H19.527V199.834H29.0143V197.669H17.1161V212.625H19.527ZM35.4272 212.848C38.2846 212.848 39.7579 211.062 40.1151 209.187H40.249V212.625H42.459V201.53H40.0704V207.022C40.0704 209.433 38.9319 210.683 36.4764 210.683C34.1325 210.683 33.1726 209.634 33.1726 207.558V201.53H30.7841V208.205C30.7841 210.772 32.302 212.848 35.4272 212.848ZM47.0601 212.625V207.134C47.0601 204.723 48.1539 203.473 50.5871 203.473C52.8864 203.473 53.824 204.522 53.824 206.598V212.625H56.2348V205.95C56.2348 203.383 54.7169 201.307 51.6363 201.307C48.8236 201.307 47.3503 203.093 47.0155 204.968H46.8592V201.53H44.6492V212.625H47.0601ZM63.2718 212.848C65.772 212.848 67.4015 211.643 67.8703 209.433H68.0266V212.625H70.2366V197.669H67.8257V204.544H67.6917C67.2453 202.669 65.7496 201.307 63.1155 201.307C59.7448 201.307 57.825 203.629 57.825 207.089C57.825 210.504 59.7671 212.848 63.2718 212.848ZM60.2582 207.089C60.2582 204.41 61.6422 203.495 63.9638 203.495C66.4417 203.495 67.8257 204.656 67.8257 207.022V207.201C67.8257 209.522 66.3747 210.638 64.0085 210.638C61.6199 210.638 60.2582 209.745 60.2582 207.089ZM77.7116 212.848C80.8368 212.848 82.8905 211.62 82.8905 209.544C82.8905 207.714 81.6851 206.821 79.051 206.486L76.4838 206.129C74.8096 205.906 74.3632 205.593 74.3632 204.723C74.3632 203.673 75.0775 203.227 77.1089 203.227C79.5644 203.227 80.2341 203.919 80.2341 205.236V205.37H82.6227V205.303C82.6227 202.669 80.5689 201.307 77.1759 201.307C73.7604 201.307 71.9969 202.691 71.9969 204.633C71.9969 206.486 73.2693 207.379 75.3677 207.647L78.4036 208.049C79.9886 208.272 80.5243 208.562 80.5243 209.477C80.5243 210.46 79.8769 210.906 77.7116 210.906C75.39 210.906 74.5194 210.437 74.5194 208.986V208.808H72.1086V208.875C72.1086 211.442 74.1399 212.848 77.7116 212.848ZM95.7222 212.625V210.46H93.7132C92.3291 210.46 91.7041 210.103 91.7041 208.741V203.54H95.7222V201.53H91.7041V199.097H89.3155V201.53H87.4404V203.54H89.3155V208.875C89.3155 211.576 90.7888 212.625 93.1774 212.625H95.7222ZM99.6411 212.625V206.397C99.6411 204.41 100.422 203.361 102.32 203.361C103.972 203.361 104.641 204.098 104.641 205.683V206.665H107.03V205.214C107.03 203.115 105.936 201.307 103.414 201.307C101.137 201.307 99.9313 202.736 99.5965 204.522H99.4402V201.53H97.2302V212.625H99.6411ZM111.803 212.848C114.326 212.848 116.089 211.732 116.67 209.857H116.826V212.625H119.036V205.883C119.036 203.227 117.451 201.307 113.924 201.307C110.397 201.307 108.299 203.205 108.299 205.727V205.817H110.687V205.727C110.687 204.098 111.692 203.428 113.746 203.428C115.866 203.428 116.67 204.075 116.67 205.906V206.553L111.625 207.089C109.437 207.334 108.053 208.227 108.053 209.946C108.053 211.777 109.504 212.848 111.803 212.848ZM110.464 209.79C110.464 208.919 111.067 208.629 112.317 208.473L116.67 207.982C116.67 210.169 114.973 211.107 112.451 211.107C111.067 211.107 110.464 210.683 110.464 209.79ZM123.599 212.625V207.134C123.599 204.723 124.693 203.473 127.126 203.473C129.425 203.473 130.363 204.522 130.363 206.598V212.625H132.774V205.95C132.774 203.383 131.256 201.307 128.175 201.307C125.363 201.307 123.889 203.093 123.554 204.968H123.398V201.53H121.188V212.625H123.599ZM140.168 212.848C143.293 212.848 145.347 211.62 145.347 209.544C145.347 207.714 144.141 206.821 141.507 206.486L138.94 206.129C137.266 205.906 136.819 205.593 136.819 204.723C136.819 203.673 137.534 203.227 139.565 203.227C142.021 203.227 142.69 203.919 142.69 205.236V205.37H145.079V205.303C145.079 202.669 143.025 201.307 139.632 201.307C136.217 201.307 134.453 202.691 134.453 204.633C134.453 206.486 135.726 207.379 137.824 207.647L140.86 208.049C142.445 208.272 142.981 208.562 142.981 209.477C142.981 210.46 142.333 210.906 140.168 210.906C137.846 210.906 136.976 210.437 136.976 208.986V208.808H134.565V208.875C134.565 211.442 136.596 212.848 140.168 212.848ZM150.345 212.625V203.54H154.319V201.53H150.301C150.167 199.923 151.082 199.454 152.846 199.454H154.319V197.669H153.225C150.078 197.669 148.225 199.097 147.957 201.53H146.26V203.54H147.935V212.625H150.345ZM161.234 212.848C164.538 212.848 166.86 211.219 166.86 208.852V208.652H164.449V208.83C164.449 210.147 163.489 210.906 161.167 210.906C158.6 210.906 157.551 209.768 157.462 207.625H166.882C166.949 207.29 166.971 206.977 166.971 206.575C166.971 203.205 164.627 201.307 161.19 201.307C157.573 201.307 155.207 203.629 155.207 207.089C155.207 210.795 157.596 212.848 161.234 212.848ZM161.145 203.205C163.511 203.205 164.694 204.187 164.694 206.241V206.285H157.484C157.618 204.299 158.689 203.205 161.145 203.205ZM171.188 212.625V206.397C171.188 204.41 171.969 203.361 173.867 203.361C175.519 203.361 176.188 204.098 176.188 205.683V206.665H178.577V205.214C178.577 203.115 177.483 201.307 174.96 201.307C172.684 201.307 171.478 202.736 171.143 204.522H170.987V201.53H168.777V212.625H171.188Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_75_6515",
    x1: 18.4658,
    y1: -1.34432,
    x2: 18.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_75_6515",
    x1: 53.4658,
    y1: -1.34432,
    x2: 53.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_75_6515",
    x1: 89.4658,
    y1: -1.34432,
    x2: 89.4659,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_75_6515",
    x1: 125.466,
    y1: -1.34432,
    x2: 125.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_75_6515",
    x1: 161.466,
    y1: -1.34432,
    x2: 161.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_75_6515",
    x1: 196.466,
    y1: -1.34432,
    x2: 196.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_75_6515",
    x1: 232.466,
    y1: -1.34432,
    x2: 232.466,
    y2: 142.989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.0064688,
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.746449,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_75_6515",
    x1: 0,
    y1: 19.454,
    x2: 255.154,
    y2: 19.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_75_6515",
    x1: 0,
    y1: 78.454,
    x2: 255.154,
    y2: 78.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_75_6515",
    x1: 0,
    y1: 48.454,
    x2: 255.154,
    y2: 48.454,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1D6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1D6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_75_6515",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5F8FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F5F8FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_75_6515",
    x1: 60,
    y1: 16.625,
    x2: 60,
    y2: 104.625,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DAE6FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DAE6FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6515"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.625,
    width: 250,
    height: 250,
    rx: 10,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_75_6515"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(39 39.625)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBigcontact4);
export default __webpack_public_path__ + "static/media/bigcontact4.19c8035a2d924be3d4581aaa09919782.svg";
export { ForwardRef as ReactComponent };